var option_default = {
  "option": "mRTBY",
  "user_choice": "xid6d",
  "check": "QT94t",
  "image": "_2-P5-",
  "input": "FN-X2",
  "title": "_32WXO",
  "centered": "Eb4Fz",
  "with_result": "_7Zu2a",
  "list": "SYqYh",
  "with_image": "zReuq",
  "progress": "VAOmg",
  "progress_value": "fG7W2",
  "label": "gZz3M",
  "cta": "C9UhZ",
  "adornment_icon": "_2-MvI",
  "remove": "Bd1Um",
  "removeButton": "IUpsD",
  "removeButtonIcon": "cRA-R",
  "overlay": "XW-cx",
  "shown": "YD3ey",
  "dark": "KdM5g",
  "spinner": "FNSQk",
  "spin": "ADkGg"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
